import { agent } from "../utils/agent";
const API_URL = process.env.REACT_APP_API_URL;

const allRoundListing = async (rd = "", userId = "") => {
  const response = await agent.get(
    API_URL + `allRoundListing?rd=${rd}&user_id=${userId}`
  );
  return response.data;
};
const getCurrentTeamPlayer = async (teamId = "") => {
  const response = await agent.get(API_URL + `getCurrentTeamPlayer/${teamId}`);
  return response.data;
};
const getRoundTeamTopData = async (roundId) => {
  const response = await agent.get(API_URL + `getRoundTeamTopData/${roundId}`);
  return response.data;
};
const getAveragePointStat = async () => {
  const response = await agent.get(API_URL + `getAveragePointStat`);
  return response.data;
};

const Round = {
  allRoundListing,
  getCurrentTeamPlayer,
  getRoundTeamTopData,
  getAveragePointStat,
};

export default Round;
